export default __webpack_public_path__ + "static/media/back_service.4a34c9bd.jpg";